import { useAllowed } from '@/shared';

export const useWithAccess = <T extends AccessProps>(items: T[]) => {
  const allowedSet = new Set(useAllowed(items.map(item => item.action)));
  return items.filter(item => !item.action || allowedSet.has(item.action));
};
